export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7550.f8f14a59.jpg";